// const url = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME_CLOUDDINARY}/image/upload`
// const uploadImage = async(image) =>{
//     const formData = new FormData()
//     formData.append("file",image)
//     formData.append("upload_preset","ShopBuddy")

//     const dataResponse = await fetch(url,{
//         method : 'post',
//         body : formData
        
//     })
//     return dataResponse.json()
// }

// export default uploadImage

const uploadImage = async (image) => {
  try {
    // 1️⃣ Get signed params from backend
    const sigResponse = await fetch("https://ecommerce-glab.onrender.com/api/cloudinary-signature");
    const { signature, timestamp, apiKey, cloudName } = await sigResponse.json();

    // 2️⃣ Upload to Cloudinary
    const url = `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`;
    const formData = new FormData();
    formData.append("file", image);
    formData.append("api_key", apiKey);
    formData.append("timestamp", timestamp);
    formData.append("signature", signature);

    const res = await fetch(url, { method: 'POST', body: formData });
    return res.json();
  } catch (err) {
    console.error('Image upload failed:', err);
    throw err;
  }
};

export default uploadImage;

